import { Action } from 'redux';
import { put, select } from '@redux-saga/core/effects';

import { AppState, ErrorAction } from 'store';
import { BasketSagaReturnType } from 'store/sagaHelpers';
import { BasketActions, BasketActionTypes, BasketLoadingItem } from 'store/basket';
import { userHelper, errorToBasketErrorModel, analyticsHelper } from 'helpers';
import { api } from 'repositories/api';
import { BasketDetailsModel, BasketItemModel } from 'models/Basket';

export interface RemoveAllInvalidItemsAction extends Action<BasketActionTypes.REMOVE_ALL_INVALID_ITEMS> {
    loadingItems: BasketLoadingItem[];
}

export interface RemoveAllInvalidItemsActionStart extends Action<BasketActionTypes.REMOVE_ALL_INVALID_ITEMS_START> {
    loadingItems: BasketLoadingItem[];
}

export interface RemoveAllInvalidItemsActionSuccess extends Action<BasketActionTypes.REMOVE_ALL_INVALID_ITEMS_SUCCESS> {
}

export interface RemoveAllInvalidItemsActionError extends ErrorAction<BasketActionTypes.REMOVE_ALL_INVALID_ITEMS_ERROR> {
}
export function* removeAllInvalidBasketItemsQueueSaga({ loadingItems }: RemoveAllInvalidItemsAction): BasketSagaReturnType {
    yield put<BasketActions>({
        type: BasketActionTypes.REMOVE_ALL_INVALID_ITEMS_START,
        loadingItems
    });

    try {
        let state: AppState = yield select();
        const basketId = state.basketState.basket!.guid;

        for (let index = 0; index < loadingItems.length; index++) {
            const loadingItem = loadingItems[index];

            state = yield select();
            const currentEntry = state.basketState.basket!.entries.find(
                (entry: BasketItemModel) => entry.product.code === loadingItem.id
            );

            if (currentEntry?.entryNumber !== undefined) {
                yield api.hybris.removeBasketItem(userHelper.getCurrentUserName(), basketId, currentEntry.entryNumber);

                sendAnalytics(currentEntry, state.basketState.basket!);
            }
        }

        yield put<BasketActions>({
            type: BasketActionTypes.REMOVE_ALL_INVALID_ITEMS_SUCCESS
        });

        return true;
    } catch (error) {
        yield put<BasketActions>({
            type: BasketActionTypes.REMOVE_ALL_INVALID_ITEMS_ERROR,
            error: errorToBasketErrorModel(error, 'removeAllInvalidBasketItemsQueueSaga')
        });

        return false;
    }
}

function sendAnalytics(item: BasketItemModel, updatedBasket: BasketDetailsModel): void {
    analyticsHelper.withLogging(() => {
        const quantity = item.quantity;

        api.google.removeDefaultProduct(item, quantity);

        api.exponea.removeFromCart(updatedBasket, item, quantity);
    }, 'removeAllInvalidBasketItemsQueueSaga');
}
